import React, { useState } from "react";

// Style
import "./style/App.scss";

// Components
import SqApp from "@sqreem-frontend/sqapp";

// Images
import { ReactComponent as IconLogoBlack } from "./images/svg/sqreem-black.svg";
import Routes from "./routes/Routes";
import { useDispatch } from "react-redux";
import { setAppList } from "./store/components/Main.slice";
import { Link } from "react-router-dom";
import MainServices from "./services/Main.services";

const HeaderLogo = () => {
  return (
    <>
      <Link>
        <div
          className="sqreem-app-logo-default"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            if (e.ctrlKey) {
              window.open(
                process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/",
                "_blank"
              );
            } else {
              window.location.replace(
                process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "/"
              );
            }
          }}
        >
          <IconLogoBlack height={14} cursor="pointer " />
          <div
            className="ant-divider css-dev-only-do-not-override-rgwaf3 ant-divider-vertical"
            role="separator"
          ></div>
        </div>
      </Link>
    </>
  );
};

const App = () => {
  const dispatch = useDispatch();
  const props = {
    appName: process.env.REACT_APP_NAME,
    appId: process.env.REACT_APP_ID,
    version: process.env.REACT_APP_VERSION,
    router: {
      routes: Routes(),
      navigateTo: "apps",
    },
    theme: {
      darkLogo: true,
      default: "light",
      options: {
        light: {
          components: {
            Layout: {
              headerBg: "white",
              bodyBg: "white",
            },
          },
        },
      },
    },
    header: {
      showApps: false,
      logo: <HeaderLogo />,
    },
    footer: {
      prefix: "© 2025 Sqreem Technologies Pte. Ltd.",
    },
    // subApp: {
    //   logo: (
    //     <>
    //       <h2>SQREEM AI</h2>
    //       <p>Welcome to your A.I. powered digital campaign launchpad.</p>
    //     </>
    //   ),
    //   items: items.map((item) => {
    //     const [filteredItem] = appList.filter((app) => item.appId === app.id);
    //     if (!filteredItem) item.disabled = true;
    //     item.appName = filteredItem?.name || item.appName;
    //     item.description = (
    //       <>
    //         <p>{filteredItem?.description || item.appDescription}</p>
    //       </>
    //     );
    //     item.onClick = (e) => {
    //       window.open(filteredItem?.url);
    //     };

    //     return item;
    //   }),
    // },
    loggerApp: false,
    onLoadSuccess: async (userInfo) => {
      dispatch(setAppList(userInfo.appList));
      MainServices.setInfo(userInfo);
      MainServices.getPermission();
      MainServices.getV2Permission();
      
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(userInfo);
        }, 1500);
      });
    },
  };

  return <SqApp {...props} />;
};

export default App;
